import * as React from 'react';
export const GESvg = React.forwardRef(function GESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Zm1-10a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M16 9H9v5H7V9H0V7h7V2h2v5h7z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M3 4V3h1v1h1v1H4v1H3V5H2V4h1Zm9 0V3h1v1h1v1h-1v1h-1V5h-1V4h1Zm0 7v-1h1v1h1v1h-1v1h-1v-1h-1v-1h1Zm-9 0v-1h1v1h1v1H4v1H3v-1H2v-1h1Z',
      }),
    ),
  );
});
GESvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GE = {
  category: 'flag',
  colorable: false,
  name: 'GE',
  svg: GESvg,
};
